import constants from './constants';
import getCurrentLocale from './current-locale';

function getLocalePrefix() {
  const locale = getCurrentLocale();
  
  if (locale === constants.DEFAULT_LOCALE) {
    return '';
  }
  
  return locale;
}

export default getLocalePrefix;
